import * as yup from 'yup'

const schema = yup.object().shape({
  fantasyDpos: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required('Nome é obrigatório'),
        email: yup
          .string()
          .email('E-mail deve ter um formato válido')
          .required('E-mail é obrigatório'),
        kind: yup.string().required('Função é obrigatória'),
        active: yup.boolean(),
      }),
    )
    .min(1, 'Pelo menos um DPO deve ser adicionado'),
})

export default schema
